/** =========================================================
 * Project indicator templates controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-indicator-templates')
    .controller('ProjectIndicatorTemplatesController', ProjectIndicatorTemplatesController);

  ProjectIndicatorTemplatesController.$inject = ['$rootScope', '$scope', '$state', '$stateParams'];

  function ProjectIndicatorTemplatesController($rootScope, $scope, $state, $stateParams) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page project indicator templates',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'project_indicator_template',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [
            'user'
          ]
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Value',
          key: 'name',
          order: true
        }, {
          title: 'Added by user',
          key: 'user_id',
          value: function (item) {
            return item.user.name;
          },
          order: true
        }, {
          title: 'Date added',
          key: 'created_at',
          customType: 'date',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project-indicator-template.html'
        },
        edit: {
          template: 'app/views/dialogs/item-project-indicator-template.html'
        },
        delete: {}
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
